module.exports = __webpack_public_path__ + "media/images/product_large_images/stand(600)-446193d2869a348d9b1a2e0b2c16404e.png";